import { Moment } from 'moment';

import { Snapshot, Vdd, VddWithContent } from '@vi-iot/client';

import {
  RemoteDiagnosticsControlUnit,
  RemoteDiagnosticsVddListParameter,
} from '../remote-diagnostics';

import { SnapshotType } from './remote-diagnostics-snapshots.model';

export interface RemoteDiagnosticsSnapshotsState {
  // snapshots
  fetchSnapshotsLoading: boolean;
  fetchSnapshotsSuccess: boolean;
  fetchSnapshotsError: any;
  snapshots: Snapshot[];
  snapshotType: SnapshotType;
  filterDate: Moment;
  isShowingMoreSnapshots: boolean;
  selectedControlUnit: RemoteDiagnosticsControlUnit;
  vddListForSelectedControlUnit: RemoteDiagnosticsVddListParameter[];
  selectedParametersForNewSnapshot: Vdd[];

  // installation vdd list
  installationVDDList: Vdd[];
  fetchInstallationVDDListLoading: boolean;
  fetchInstallationVDDListSuccess: boolean;
  fetchInstallationVDDListError: any;

  // create snapshot
  createSnapshotLoading: boolean;
  createSnapshotSuccess: boolean;
  createSnapshotError: any;

  // fetch vdds from snapshot
  fetchSnapshotDetailsLoading: boolean;
  fetchSnapshotDetailsSuccess: boolean;
  fetchSnapshotDetailsError: any;
  snapshotDetails: VddWithContent[];

  // read vdds
  finishedReadingVddsAtDate: Date;

  // select snapshot
  selectedSnapshot: Snapshot;

  // optimization flag
  showValues: boolean;
  lastsNumberOfSnapshots: number;
}

export const SHOW_MORE_BACKUPS_THRESHOLD = 3;
